import { Box, Link, Typography } from '@mui/material'
import { COPY_RIGHT, ICP_LINK, ICP_NUMBER, SUPPORT } from 'src/constants/env'
import { useIntl } from '@frontend/t7nd'

export const InfoMessages = {
  COPYRIGHT: {
    id: '版权所有',
    defaultMessage: '版权所有',
  },
  TECH_SUPPORT: {
    id: '技术支持',
    defaultMessage: '技术支持',
  },
  ICP_NUMBER: {
    id: '备案号',
    defaultMessage: '备案号',
  },
} as const

export function Info() {
  const { formatMessage } = useIntl()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        color: '#fff',
        opacity: 0.6,
        transform: 'scale(1)',
        position: 'absolute',
        bottom: 0,
        left: '20px',
      }}
    >
      <Box display="flex">
        {COPY_RIGHT && (
          <Typography
            variant="caption"
            sx={{
              display: 'inline-block',
              fontSize: '10px',
              marginRight: '6px',
            }}
          >
            © {formatMessage(InfoMessages.COPYRIGHT)}：{COPY_RIGHT}
          </Typography>
        )}
        {SUPPORT && (
          <Typography
            variant="caption"
            sx={{
              display: 'inline-block',
              fontSize: '10px',
            }}
          >
            {`| ${formatMessage(InfoMessages.TECH_SUPPORT)}：${SUPPORT}`}
          </Typography>
        )}
      </Box>
      {ICP_NUMBER && (
        <Box display="flex" marginBottom={'18px'}>
          <Link href={ICP_LINK} target="_blank">
            <Typography
              variant="caption"
              sx={{
                fontSize: '10px',
                color: '#fff',
              }}
            >
              {formatMessage(InfoMessages.ICP_NUMBER)}：{ICP_NUMBER}
            </Typography>
          </Link>
        </Box>
      )}
    </Box>
  )
}
